import React, { memo } from 'react';
import { classNames } from '../../utils/classNames';

const GRID_CLASSES = {
	1: 'grid grid-cols-1 gap-3',
	2: 'grid grid-cols-1 sm:grid-cols-2 gap-3',
	3: 'grid grid-cols-2 sm:grid-cols-3 gap-3',
	4: 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3',
	5: 'grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3',
	6: 'grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3',
};

export const CheckboxGrid = memo(function CheckboxGrid({
	options = [],
	value = [],
	onChange,
	columns = 3,
	max = null,
	onMaxExceeded,
	withImage = false,
	className,
}) {
	function toggle(optionValue) {
		if (!onChange) return;
		const nextChecked = !value.includes(optionValue);

		if (nextChecked && max != null && value.length >= max) {
			if (onMaxExceeded) onMaxExceeded(max);
			return;
		}

		const next = nextChecked
			? [...value, optionValue]
			: value.filter((item) => item !== optionValue);
		onChange(next);
	}

	const gridClass = GRID_CLASSES[columns] || GRID_CLASSES[3];

	return (
		<div className={classNames(gridClass, className)}>
			{options.map((option) => {
				const checked = value.includes(option.value);
				return (
					<button
						key={option.value}
						type='button'
						onClick={() => toggle(option.value)}
						className={classNames(
							'inline-flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2 text-left shadow-sm transition',
							checked
								? 'border-sky-400 bg-sky-50 text-sky-800'
								: 'border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300 hover:bg-zinc-50',
						)}
					>
						<span className='relative inline-flex h-4 w-4 items-center justify-center'>
							<span
								className={classNames(
									'inline-flex h-4 w-4 items-center justify-center rounded border',
									checked
										? 'border-sky-500 bg-sky-500 text-white'
										: 'border-zinc-300 bg-white',
								)}
							>
								{checked && (
									<svg
										className='h-3 w-3'
										viewBox='0 0 20 20'
										fill='currentColor'
									>
										<path
											fillRule='evenodd'
											d='M16.704 5.29a1 1 0 010 1.42l-7.2 7.2a1 1 0 01-1.414 0l-3.2-3.2a1 1 0 111.414-1.42l2.493 2.494 6.493-6.494a1 1 0 011.414 0z'
											clipRule='evenodd'
										/>
									</svg>
								)}
							</span>
						</span>
						{withImage && option.image ? (
							<img
								src={option.image}
								alt={option.label}
								loading='lazy'
								className='h-7 w-7 shrink-0'
							/>
						) : null}
						<span className='text-xs font-medium'>{option.label}</span>
					</button>
				);
			})}
		</div>
	);
});

export default CheckboxGrid;